import React from 'react'
import { formatDistanceToNow } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { UsernameById } from '@/entities/user'

import {
	DescriptionDetail,
	DescriptionGroup,
	DescriptionList,
	DescriptionTerm,
} from '@/shared/components/ui/description-list'

import { useScenarioItemContext } from './ScenarioItemProvider'

export const ScenarioModalDescription = () => {
	const { t } = useTranslation()

	const context = useScenarioItemContext()
	const scenario = context.scenario

	return (
		<DescriptionList className='my-4 flex items-start gap-10'>
			<DescriptionGroup>
				<DescriptionTerm>
					{t('last_modified_at', { defaultValue: 'Last modified' })}
				</DescriptionTerm>
				<DescriptionDetail>
					{scenario?.updated_at ? (
						<p className='flex items-center font-medium'>
							{formatDistanceToNow(new Date(scenario?.updated_at + 'Z'), {
								addSuffix: true,
							})}
							{scenario?.updated_by && ' by '}
							{scenario?.updated_by && (
								<UsernameById userId={scenario.updated_by} />
							)}
						</p>
					) : (
						'-'
					)}
				</DescriptionDetail>
			</DescriptionGroup>
		</DescriptionList>
	)
}
